// extracted by mini-css-extract-plugin
export default {"title":"e5-z","warning":"f5-z","sizeOptionsLegendText":"g5-z"};